module.exports = __webpack_public_path__ + "img/碳標籤圖示.efec9ba9.jpg";